"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.padNumber = void 0;
/* Adds a '0' in front of number below 10 to keep formatting consistent */
const padNumber = (n) => (n < 10 ? "0" : "") + n;
exports.padNumber = padNumber;
//# sourceMappingURL=padNumber.js.map